const pageActionTypes =  {
    CANCEL_PAGE: "CANCEL_PAGE",
    LOAD_PAGE: "LOAD_PAGE",
    LOADED_PAGE: "LOADED_PAGE",
    ERROR_LOADING_PAGE: "ERROR_LOADING_PAGE",
    SAVE_PAGE: "SAVE_PAGE",
    SAVED_PAGE: "SAVED_PAGE",
    ERROR_SAVING_PAGE: "ERROR_SAVING_PAGE",
    CHANGE_FIELD_VALUE: "CHANGE_FIELD_VALUE",
    CHANGE_PERMISSIONS: "CHANGE_PERMISSIONS",
    FETCH_CACHE_PROVIDER_LIST: "FETCH_CACHE_PROVIDER_LIST",
    FETCHED_CACHE_PROVIDER_LIST: "FETCHED_CACHE_PROVIDER_LIST",
    ERROR_FETCHING_CACHE_PROVIDER_LIST: "ERROR_FETCHING_CACHE_PROVIDER_LIST",
    EDITING_PAGE_MODULE: "EDITING_PAGE_MODULE",
    CANCEL_EDITING_PAGE_MODULE: "CANCEL_EDITING_PAGE_MODULE",
    DELETING_PAGE_MODULE: "DELETING_PAGE_MODULE",
    DELETED_PAGE_MODULE: "DELETED_PAGE_MODULE",
    ERROR_DELETING_PAGE_MODULE: "ERROR_DELETING_PAGE_MODULE",
    COPYING_APPEARANCE_TO_DESCENDANT_PAGES: "COPYING_APPEARANCE_TO_DESCENDANT_PAGES",
    COPIED_APPEARANCE_TO_DESCENDANT_PAGES: "COPIED_APPEARANCE_TO_DESCENDANT_PAGES",
    ERROR_COPYING_APPEARANCE_TO_DESCENDANT_PAGES: "ERROR_COPYING_APPEARANCE_TO_DESCENDANT_PAGES",
    COPYING_PERMISSIONS_TO_DESCENDANT_PAGES: "COPYING_PERMISSIONS_TO_DESCENDANT_PAGES",
    COPIED_PERMISSIONS_TO_DESCENDANT_PAGES: "COPIED_PERMISSIONS_TO_DESCENDANT_PAGES",
    ERROR_COPYING_PERMISSIONS_TO_DESCENDANT_PAGES: "ERROR_COPYING_PERMISSIONS_TO_DESCENDANT_PAGES",
    ADD_CUSTOM_URL: "ADD_CUSTOM_URL",
    REPLACE_CUSTOM_URL: "REPLACE_CUSTOM_URL",
    DELETE_CUSTOM_URL: "DELETE_CUSTOM_URL",
    SELECT_PAGE_SETTING_TAB: "SELECT_PAGE_SETTING_TAB",
    DELETE_PAGE: "DELETE_PAGE",
    DELETED_PAGE: "DELETED_PAGE",
    ERROR_DELETING_PAGE: "ERROR_DELETING_PAGE",
    RETRIEVED_CACHED_PAGE_COUNT: "RETRIEVED_CACHED_PAGE_COUNT",
    CLEARED_CACHED_PAGE: "CLEARED_CACHED_PAGE",
    CLEAR_SELECTED_PAGE: "CLEAR_SELECTED_PAGE",
    GET_CURRENT_SELECTED_PAGE: "GET_CURRENT_SELECTED_PAGE",
    UPDATED_PAGE_MODULE_COPY: "UPDATED_PAGE_MODULE_COPY",
    GET_WORKFLOW_LIST: "GET_WORKFLOW_LIST",
    CUSTOM_PAGE_DETAILS_UPDATED: "CUSTOM_PAGE_DETAILS_UPDATED"
};

export default pageActionTypes;
